import React from 'react';
import { Navigate } from 'react-router';
import { useUser } from '~/providers/user';
function PermissionChecker(props) {
    const { hasPermission } = useUser();
    const requiredAllPermissions = props.requiredAllPermissions || [];
    const requiredAnyPermissions = props.requiredAnyPermissions || [];
    if (!requiredAnyPermissions.length && !requiredAllPermissions.length) {
        return React.createElement(React.Fragment, null);
    }
    const missingAllPermissions = requiredAllPermissions.filter(ap => !hasPermission(ap));
    let missingAnyPermissions = [];
    if (requiredAnyPermissions.length && !requiredAnyPermissions.some(ap => hasPermission(ap))) {
        missingAnyPermissions = requiredAnyPermissions;
    }
    if (missingAllPermissions.length === 0 && missingAnyPermissions.length === 0) {
        return props.children;
    }
    if (props.isRoute) {
        let message = 'Missing Required Permissions for Route Access:';
        message += ` ${requiredAllPermissions.join(', ')}`;
        message += ` ${requiredAnyPermissions.join(', ')}`;
        console.error(message);
        return React.createElement(Navigate, { to: '/401' });
    }
    return React.createElement(React.Fragment, null);
}
export default PermissionChecker;
